import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { IssueTypeSettingsGeneralViewTopBar } from "./TopBar"

export const issueTypeGeneralViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: IssueTypeSettingsGeneralViewTopBar,
}
